/* =====================================================================
   COSMO KIT JS — shared helpers for the Cosmo sections (deferred, ~4 KB)
   - one delegated add-to-cart for every Cosmo card / cart add-on
   - rail arrows
   - free-shipping bar live updates (works with the theme's own cart too)
   - cart drawer add-on: hides products already in the cart
   - sticky collection toolbar offset under the mobile header
   No scroll listeners on the page, no polling, no libraries.
   ===================================================================== */
(function () {
  'use strict';
  var K = window.CosmoKit || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- money ---------- */
  function money(cents) {
    cents = Math.round(cents || 0);
    var fmt = K.moneyFormat || '{{amount}}';
    function delim(n, d, t, s) {
      var parts = (n / 100).toFixed(d).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (parts[1] ? s + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') { return delim(cents, 0, ',', '.'); }
      if (k === 'amount_with_comma_separator') { return delim(cents, 2, '.', ','); }
      if (k === 'amount_no_decimals_with_comma_separator') { return delim(cents, 0, '.', ','); }
      return delim(cents, 2, ',', '.');
    });
  }
  K.money = money;

  /* ---------- free-shipping bar ---------- */
  function updateFreeShip(total) {
    var bars = document.querySelectorAll('[data-cfs]');
    if (!bars.length || !K.freeShip) { return; }
    var goal = K.freeShip, left = Math.max(0, goal - total), p = Math.min(1, total / goal);
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i], msg = bar.querySelector('.cfs__msg'), html;
      if (total <= 0) { html = bar.getAttribute('data-msg-empty'); }
      else if (left > 0) { html = bar.getAttribute('data-msg-left'); }
      else { html = bar.getAttribute('data-msg-done'); }
      html = (html || '').replace('[amount]', '<b>' + money(left) + '</b>').replace('[goal]', '<b>' + money(goal) + '</b>');
      if (msg && msg.innerHTML !== html) {
        msg.innerHTML = html;
        bar.classList.remove('is-bump'); void bar.offsetWidth; bar.classList.add('is-bump');
      }
      bar.classList.toggle('is-done', total > 0 && left === 0);
      bar.style.setProperty('--cfs-p', p.toFixed(3));
    }
  }
  var cartTimer = 0;
  function refreshCart() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { K.cartTotal = c.total_price; updateFreeShip(c.total_price); })
        .catch(function () {});
    }, 150);
  }
  K.refreshCart = refreshCart;

  /* ---------- add to cart ---------- */
  function openThemeCart() {
    try { if (window.ajaxCart && typeof ajaxCart.load === 'function') { ajaxCart.load(); } } catch (e) {}
    try { if (window.jQuery) { jQuery('body').trigger('drawer.open'); } } catch (e) {}
  }
  function add(btn) {
    if (btn.classList.contains('is-loading')) { return; }
    var id = Number(btn.getAttribute('data-cosmo-add'));
    if (!id) { return; }
    btn.classList.remove('is-added');
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { throw d; } return d; });
    }).then(function () {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 2200);
      if (!btn.hasAttribute('data-cosmo-stay')) { openThemeCart(); }
      else { try { if (window.ajaxCart) { ajaxCart.load(); } } catch (e) {} }
      refreshCart();
      document.dispatchEvent(new CustomEvent('cosmo:cart:changed', { detail: { variantId: id, source: btn } }));
    }).catch(function (err) {
      btn.classList.remove('is-loading');
      var msg = (err && (err.description || err.message)) || 'Could not add to cart';
      try { if (window.ShopifyAPI && ShopifyAPI.onError) { ShopifyAPI.onError({ responseText: JSON.stringify(err) }); return; } } catch (e) {}
      window.alert(msg);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cosmo-add]');
    if (btn) { e.preventDefault(); add(btn); }
  });

  /* other add-to-cart paths: other sections and the theme's own jQuery cart */
  document.addEventListener('cosmo:cart:added', refreshCart);
  function hookJquery() {
    if (!window.jQuery) { return; }
    jQuery(document).ajaxComplete(function (ev, xhr, opts) {
      if (opts && /\/cart\/(add|change|update|clear)/.test(opts.url || '')) { refreshCart(); }
    });
  }

  /* ---------- rails ---------- */
  function initRail(r) {
    if (r.__crl) { r.__crl(); return; }
    var track = r.querySelector('[data-crl-track]');
    if (!track) { return; }
    var prev = r.querySelector('[data-crl-prev]'), next = r.querySelector('[data-crl-next]');
    if (!track) { return; }
    var rtl = getComputedStyle(track).direction === 'rtl', ticking = false;
    function state() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth - 2, x = Math.abs(track.scrollLeft);
      if (prev) { prev.disabled = x <= 2; }
      if (next) { next.disabled = x >= max; }
    }
    function go(dir) { track.scrollBy({ left: dir * (rtl ? -1 : 1) * track.clientWidth * 0.9, behavior: 'smooth' }); }
    if (prev) { prev.addEventListener('click', function () { go(-1); }); }
    if (next) { next.addEventListener('click', function () { go(1); }); }
    track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(state); } }, { passive: true });
    r.__crl = state; /* re-run when a hidden rail (tab) is shown */
    state();
  }
  K.initRails = function (scope) {
    var rails = (scope || document).querySelectorAll('[data-crl]');
    for (var i = 0; i < rails.length; i++) { initRail(rails[i]); }
  };

  /* ---------- cart drawer add-on: hide what is already in the cart ---------- */
  function filterAddon() {
    var box = document.querySelector('[data-cart-container]');
    if (!box) { return; }
    var cao = box.querySelector('[data-cao]');
    if (!cao) { return; }
    var inCart = {}, keys = box.querySelectorAll('.ajaxcart__product [data-id]');
    for (var i = 0; i < keys.length; i++) { inCart[String(keys[i].getAttribute('data-id')).split(':')[0]] = true; }
    var items = cao.querySelectorAll('[data-cao-variant]'), shown = 0, max = Number(cao.getAttribute('data-cao-max')) || 6;
    for (var j = 0; j < items.length; j++) {
      var hide = inCart[items[j].getAttribute('data-cao-variant')] || shown >= max;
      items[j].hidden = !!hide;
      if (!hide) { shown++; }
    }
    cao.hidden = keys.length === 0 || shown === 0;
  }
  function watchDrawer() {
    var box = document.querySelector('[data-cart-container]');
    if (!box || !('MutationObserver' in window)) { return; }
    new MutationObserver(filterAddon).observe(box, { childList: true });
    filterAddon();
  }

  /* ---------- sticky collection toolbar: sit under the fixed mobile header ---------- */
  function stickyTop() {
    var h = document.querySelector('.header-top-mobile');
    var v = h && h.offsetHeight ? h.offsetHeight : 0;
    document.documentElement.style.setProperty('--cm-sticky-top', v + 'px');
  }

  function start() {
    K.initRails();
    updateFreeShip(K.cartTotal || 0);
    hookJquery();
    watchDrawer();
    if (document.querySelector('.page-collection')) {
      stickyTop();
      window.addEventListener('resize', stickyTop, { passive: true });
    }
    document.addEventListener('shopify:section:load', function (e) { K.initRails(e.target); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
